import { UserAPIService } from "./user";
import api from "..";

export default new UserAPIService(api);
